import { z } from "zod";
import { inviteRoleSchema } from "./auth";

export const memberRoleUpdateSchema = z.object({ role: inviteRoleSchema }).strict();

export type MemberRoleUpdate = z.infer<typeof memberRoleUpdateSchema>;
